import React from "react";
import cns from "classnames";
import { makeStyles, Paper } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { CategoryBadge, TodoCategory } from "@graphql";

const BadgeNamesMap = {
  [TodoCategory.MyTask]: locale.ticketsCard.categoryMyTask,
  [TodoCategory.DelegatedByMe]: locale.ticketsCard.categoryDelegatedByMe,
  [TodoCategory.NotContacted]: locale.ticketsCard.categoryNotContacted,
  [TodoCategory.NonAnswers]: locale.ticketsCard.categoryNonAnswers,
  [TodoCategory.Birthday]: locale.ticketsCard.categoryBirthday,
  [TodoCategory.Applications]: locale.ticketsCard.categoryApplications,
  [TodoCategory.Team]: locale.ticketsCard.categoryTeam,
  [TodoCategory.Travel]: locale.ticketsCard.categoryTravel,
  [TodoCategory.Accommodation]: locale.ticketsCard.categoryAccommodation
  // [TodoCategory.KitAttestation]: locale.KitAttestation
};

type Props = {
  selectedTeam: string;
  badge: CategoryBadge;
  onClick: (badge: CategoryBadge) => void;
  active: boolean;
  style?: React.CSSProperties;
};

function TicketSearchCategoryItem({
  selectedTeam,
  badge,
  onClick,
  active,
  ...rest
}: Props): React.ReactElement<Props> {
  const styles = useStyles({});
  const { Category, Read, Unread } = badge;
  const rootClassName = cns({
    [styles.root]: true,
    [styles.rootActive]: active
  });

  const unreadClassNames = cns(styles.badge, styles.unread, {
    [styles.onlyUnread]: Read <= 0
  });

  const newMessagesClassNames = cns(styles.badge, styles.newComments);

  // TODO: CRMDEV-1682 remove this if KitAttestation is not needed (2 months after release)
  // should be removed from user profiles as well
  const isKitAttestation = Category === TodoCategory.KitAttestation;

  if (isKitAttestation) {
    return null;
  }

  return (
    <Paper
      elevation={2}
      className={rootClassName}
      onClick={() => {
        onClick(badge);
      }}
      style={rest.style}
    >
      {Read > 0 && <div className={unreadClassNames}>{Read}</div>}
      {Unread > 0 && <div className={newMessagesClassNames}>{Unread}</div>}
      <div className={styles.label}>
        {Category === TodoCategory.Team ? selectedTeam : BadgeNamesMap[Category]}
      </div>
    </Paper>
  );
}

const useStyles = makeStyles({
  root: {
    position: "relative",
    width: "170px",
    height: "30px",
    backgroundColor: "#EAEAEA",
    cursor: "pointer",
    marginRight: "20px"
  },
  rootActive: {
    backgroundColor: "#bdbcbc"
  },
  badge: {
    position: "absolute",
    top: "-9px",
    borderRadius: "50%",
    minWidth: "20px",
    height: "20px",
    padding: "4px 2px",
    textAlign: "center",
    fontSize: "10px",
    color: "#FFFFFF"
  },
  unread: {
    right: "15px",
    backgroundColor: "#659EFF"
  },
  onlyUnread: {
    right: "-8px"
  },
  newComments: {
    right: "-8px",
    backgroundColor: "#C35252"
  },
  label: {
    padding: "5px 0",
    textAlign: "center"
  }
});

export default TicketSearchCategoryItem;
